import { Link } from "@tanstack/react-router";
import Logo from "./Icon.tsx"

function Footer() {

    return (
        <div className="bg-slate-800/70 relative bottom-0 w-full text-white p-4 text-center z-0">
            {/* Navigation Links */}
            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mb-2 text-sm md:text-base">
                {[
                    { path: "/about", label: "Про нас" },
                    { path: "/blog", label: "Новини" },
                    { path: "/vacancies", label: "Вакансії" },
                    { path: "/contacts", label: "Контакти" },
                    { path: "/login", label: "Увійти" },
                    { path: "/register", label: "Реєстрація" },
                ].map(({ path, label }) => (
                    <Link to={path} key={path} className="cursor-pointer underline hover:text-gray-300 transition">
                        {label}
                    </Link>
                ))}
            </div>

            {/* Logo and Description */}
            <div className="flex flex-col md:flex-row justify-center items-center text-center md:text-left gap-4 my-4 px-4">
                <div className="grayscale flex justify-center">
                    <Logo />
                </div>

                <h3 className="max-w-lg text-white/50 text-sm md:text-base">
                    БО «БФ «Завжди вірний» - неприбуткова волонтерська організація з метою допомоги ветеранам.
                    Долучайтеся до зборів, допоможемо нашим військовим разом.
                </h3>
            </div>

            <div className="flex justify-center items-center gap-4 my-4">
                {/* Instagram */}
                <a href="https://www.instagram.com/samper_fi_foundation">
                    <svg className="stroke-white/50 hover:stroke-chromatic" width="32" height="32" fill="none" stroke="#ffffff" strokeWidth="1.5"
                         viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d='M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6zm14-2.9h.5'/>
                        <path d='M15.462 11.487a3.5 3.5 0 1 1-6.925 1.026 3.5 3.5 0 0 1 6.925-1.026'/>
                    </svg>
                </a>
                {/* Facebook */}
                <a href="https://www.facebook.com/share/1BmMN8Gbw2/?mibextid=wwXIfr">
                    <svg className="stroke-white/50 hover:stroke-chromatic" width="32" height="32" fill="none" stroke="#ffffff" strokeWidth="1.5"
                         viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d='M6.5 10v4h3v7h4v-7h3l1-4h-4V8c0-.545.455-1 1-1h3V3h-3c-2.723 0-5 2.277-5 5v2z'/>
                    </svg>
                </a>
            </div>

            <p className="text-white/50">© 2025. Усі права зареєстровані <br />
                <span onClick={() => window.location.href = "/policy-page"} className="underline cursor-pointer">Політика конфіденційності</span></p>
        </div>
    );
}

export default Footer;